export default import.meta.ROLLDOWN_FILE_URL_MdgOQA2XpPQ_$IYxvTwusQ